import { initAjaxLoadItemsTrigger } from 'allink-core-static/js/modules/ajax-load-items';
import { initMasonry } from 'allink-core-static/js/modules/masonry';

$(function(){

    var options = {
        ajax_load_transition_duration: 100,
    };

    // init modules
    initAjaxLoadItemsTrigger(options);
    initMasonry(options);

    // re-init when softpage has been opened
    $(window).on('softpage:opened',function(){
        initAjaxLoadItemsTrigger(options);
        initMasonry(options);

        console.log(options);
        $('.schedule-table').each((key, val) => {
            const $val = $(val);
            const $inner = $val.find('.inner');
            const initHeight = $inner.height();
            if ($val.height() > 500) {
                $val.addClass('cover');
                $inner.height(500);
                $val.find('.show-more-button a').click((event) => {
                    event.preventDefault();
                    $inner.height(initHeight);
                    $val.addClass('show-full');
                });
            } else {
                $val.addClass('show-full');
            }
        });
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/ajax-load-items.js